import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import pelleHotdogPetite from "@/assets/products/pelle-hotdog-petite.png";
import pelleHotdogMoyenne from "@/assets/products/pelle-hotdog-moyenne.png";
import pelleHotdogGrande from "@/assets/products/pelle-hotdog-grande.png";

const config: ProductPageConfig = {
  name: "Pelles à hot dog",
  breadcrumbName: "Pelles à hot dog",
  subtitle: "Pelles kraft pour hot dogs, pratiques et éco-responsables",
  features: [
    "Carton kraft résistant",
    "Contact alimentaire",
    "Recyclable et compostable",
    "Disponible en 3 tailles",
    "Disponible en stock",
  ],
  variants: [
    {
      name: "Petite",
      dimensions: "160 x 50 x 30 mm",
      material: "Carton kraft",
      packaging: "Carton de 1000 (10 sachets de 100)",
      palette: "75 cartons",
      image: pelleHotdogPetite,
    },
    {
      name: "Moyenne",
      dimensions: "208 x 70 x 75 mm",
      material: "Carton kraft",
      packaging: "Carton de 400 (4 sachets de 100)",
      palette: "24 cartons",
      image: pelleHotdogMoyenne,
    },
    {
      name: "Grande",
      dimensions: "260 x 120 x 70 mm",
      material: "Carton kraft",
      packaging: "Carton de 200 (4 sachets de 50)",  
      palette: "25 cartons",
      image: pelleHotdogGrande,
    },
  ],
};

const PelleHotdog = () => <ProductPageLayout config={config} />;
export default PelleHotdog;
